// import 'babel-polyfill';
require('es6-promise').polyfill();
import './lib/shim';
import Vue from 'vue';
import router from './router';
import store from './store';
import Filter from './filters';
import VueTap from './directives/vue-tap';
import App from './App';
import './style/common.less';

import {inApp} from './constants';
import JSBridge from './service/js-bridge';

if(inApp) {
    window.clientAction = JSBridge.clientAction;
}

Vue.use(Filter);
Vue.use(VueTap);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js